import * as React from 'react';
import classNames from 'classnames';
import styles from './SectionHeader.css';
var SectionHeader = function (props) {
    var text = props.text;
    return React.createElement("h2", { className: classNames(styles.sectionHeader, props.className) }, text);
};
export default SectionHeader;
